document.addEventListener('DOMContentLoaded', () => {
    const searchFiltersToggle = document.getElementById('c-filters-toggle');
    const searchFilters = document.getElementById('c-filters');
    if (!searchFiltersToggle || !searchFilters) return;
    searchFiltersToggle.addEventListener('click', () => {
        searchFiltersToggle.classList.toggle('c-filters--open');
        searchFilters.classList.toggle('tw-hidden');
    });
});
